// Removing one checklist item from a production proof
// (docs/checklist-item-remove-proposal.md). Pure, so the confirm's wording is
// tested without mounting anything.

export const STATION_STARTED = "STATION_STARTED"
export const STATION_JOB_READY = "STATION_JOB_READY"

// What identifies an item, the same three keys the backend's `merge_chi` and
// `remove_chi` match on.
export const CHI_KEYS = ["text", "production_station", "production_line"]

export function chiKey(chi) {
    return Object.fromEntries(CHI_KEYS.map(k => [k, chi?.[k] ?? null]))
}

export function sameChi(a, b) {
    return CHI_KEYS.every(k => (a?.[k] ?? null) === (b?.[k] ?? null))
}

/** The translation key a system item is shown with, or null for a task. */
export function chiLabelKey(chi) {
    if (chi?.text === STATION_STARTED) return "chi_station_started"
    if (chi?.text === STATION_JOB_READY) return "chi_station_finished"
    return null
}

/** What removing `chi` from `checklist` changes, as one line for the confirm.
 *
 * Returns `{ key, warn }`: `key` is a translation key holding `{station}`, and
 * `warn` is true when the panel itself stops being finished, which the dialog
 * shows in red. Mirrors what the backend derives after the removal:
 *   - a task changes nothing but the task;
 *   - Station started sends the station back to Waiting, unless its Station
 *     finished stays, which keeps it Ready;
 *   - Station finished sends it back to Working, and on a finished proof the
 *     ready date is cleared, so the panel is no longer ready.
 */
export function removalEffect(checklist, chi, proofReady) {
    const same_station = c =>
        c.production_station === chi.production_station && c.production_line === chi.production_line
    if (chi.text === STATION_STARTED) {
        const finished = (checklist || []).some(c => c.text === STATION_JOB_READY && same_station(c))
        return { key: finished ? "remove_chi_effect_started_ready" : "remove_chi_effect_started", warn: false }
    }
    if (chi.text === STATION_JOB_READY) {
        return proofReady
            ? { key: "remove_chi_effect_finished_unready", warn: true }
            : { key: "remove_chi_effect_finished", warn: false }
    }
    return { key: "remove_chi_effect_task", warn: false }
}
